import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';

type Payload = {
  emailAddress: string;
};

export const useRequestPasswordReset = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return fetchJson('/authentication/request-password-reset-link', {
        method: 'POST',
        body,
      });
    },
  });
};
